import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type UserPermissionsFetchFailedAction = {
	type: 'USER_PERMISSIONS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): UserPermissionsFetchFailedAction => ({
	type: 'USER_PERMISSIONS_FETCH_FAILED',
	payload,
});
